import { render, staticRenderFns } from "./linuc101Command.vue?vue&type=template&id=ed72ebe8"
import script from "./linuc101Command.vue?vue&type=script&lang=js"
export * from "./linuc101Command.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports